module.exports = __webpack_public_path__ + "static/media/zhoufeng.358524ff.jpg";